import { useEffect } from 'react';
import { getSeoConfig, SITE_URL } from '../seo';

const setMeta = (attribute, value, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${value}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

const setCanonical = (href) => {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

export default function SEO({ pathname }) {
  useEffect(() => {
    const config = getSeoConfig(pathname);
    document.title = config.title;
    setMeta('name', 'description', config.description);
    setMeta('name', 'robots', config.robots);
    setMeta('property', 'og:title', config.title);
    setMeta('property', 'og:description', config.description);
    setMeta('property', 'og:url', config.canonical);
    setMeta('property', 'og:type', config.type);
    setMeta('property', 'og:image', config.image);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', config.title);
    setMeta('name', 'twitter:description', config.description);
    setMeta('name', 'twitter:image', config.image);
    setCanonical(config.canonical);

    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${SITE_URL}/#organization`,
          name: 'Lending Mitra',
          url: SITE_URL,
          logo: config.image,
        },
        {
          '@type': 'WebSite',
          '@id': `${SITE_URL}/#website`,
          name: 'Lending Mitra',
          url: SITE_URL,
          publisher: { '@id': `${SITE_URL}/#organization` },
        },
      ],
    };

    let script = document.head.querySelector('script[data-lending-mitra-schema]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.lendingMitraSchema = 'true';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);
  }, [pathname]);

  return null;
}
